import { Controller } from "@hotwired/stimulus"

// Browsers without the Popover API (Safari < 17) have no showPopover or
// hidePopover. The menu then stays closed and the trigger is a plain link to
// the category page.
export default class extends Controller {
  static targets = ["trigger", "popover"]

  show() {
    clearTimeout(this.hideTimeout)
    if (this.popoverSupported) this.popoverTarget.showPopover()
  }

  hide() {
    this.hideTimeout = setTimeout(() => {
      if (this.popoverSupported) this.popoverTarget.hidePopover()
    }, 150)
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
  }

  get popoverSupported() {
    return typeof this.popoverTarget.showPopover === "function"
  }
}
